import api from './api';

const detail = (e: any, fallback: string) =>
  e?.response?.data?.detail || e?.message || fallback;

export const getMyProfile = async () => {
  // Load call — callers fall back silently on failure (no error toast).
  const res = await api.get('/my_employee_profile');
  return res.data;
};

export const updateMyProfile = async (id: string, payload: Record<string, any>) => {
  try {
    const res = await api.put(`/update_employee/${id}`, payload);
    return res.data;
  } catch (e: any) {
    throw new Error(detail(e, 'Could not save your profile'));
  }
};

export const uploadAvatar = async (file: File) => {
  try {
    const formData = new FormData();
    formData.append('uploaded_file', file);
    const res = await api.post('/upload_avatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data; // { success, public_url }
  } catch (e: any) {
    throw new Error(detail(e, 'Photo upload failed'));
  }
};

export const removeAvatar = async () => {
  try {
    const res = await api.delete('/upload_avatar');
    return res.data; // { success }
  } catch (e: any) {
    throw new Error(detail(e, 'Could not remove photo'));
  }
};

// My Profile → Bank Details. The account payouts are made FROM, plus the
// constants each bank prints on every row of a bulk-upload sheet; they prefill
// the salary / expense "Export Excel" dialogs. Stored on the caller's User row,
// so admins (who have no Employee record) can hold them too.
export type PayoutBank = {
  bankName?: string | null;
  accountNumber?: string | null;
  ifscCode?: string | null;
  senderAddress?: string | null;
  remitterName?: string | null;
  paymentMethodName?: string | null;
  paymentInstructions?: string | null;
  ccy?: string | null;
};

export const updateMyPayoutBank = async (payload: PayoutBank) => {
  try {
    const res = await api.put('/my_payout_bank', payload);
    return res.data as { success: boolean; payout_bank: PayoutBank };
  } catch (e: any) {
    throw new Error(detail(e, 'Could not save your bank details'));
  }
};

export const updateMyBasicProfile = async (payload: { first_name?: string; last_name?: string }) => {
  try {
    const res = await api.put('/my_basic_profile', payload);
    return res.data; // { success, first_name, last_name, name }
  } catch (e: any) {
    throw new Error(detail(e, 'Could not save your name'));
  }
};
